// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27bvw","content":"styles_content__1zZAo"};